module.exports = __webpack_public_path__ + "media/brands/pontiac-0643e331.png";